import { render } from "./TemplateModalParkingSpot.vue?vue&type=template&id=b7af0764&ts=true"
import script from "./TemplateModalParkingSpot.vue?vue&type=script&lang=ts"
export * from "./TemplateModalParkingSpot.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__